import { createFileRoute } from "@tanstack/react-router";
import { List } from "@/features/teammates";

const Route = createFileRoute("/_authorized/teammates/")({
  component: () => <List />,
});

export { Route };
